import "core-js/modules/es.date.to-string.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useEffect, useContext, useState } from 'react';

/**
 * Retrieves the value from a React context or throws an error if the value is null.
 */
export function useContextOrThrow(context, message) {
  var value = useContext(context);
  if (value === null) {
    throw new Error(message || "Expected a value from context ".concat(context.displayName));
  }
  return value;
}

/**
 * Custom React hook that returns the current time, updated at a specified interval.
 *
 * @param {number} [interval=1000] The interval in milliseconds at which to update the time. Defaults to 1000ms (1 second).
 * @returns {Date} The current time as a Date object.
 */
export function useNow() {
  var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
  var _useState = useState(new Date()),
    _useState2 = _slicedToArray(_useState, 2),
    time = _useState2[0],
    setTime = _useState2[1];

  // using useEffect with setInterval for this specific case
  // to create a timer that is updated every {interval} miliseconds
  // eslint-disable-next-line no-restricted-syntax
  useEffect(function () {
    var timer = setInterval(function () {
      return setTime(new Date());
    }, interval);
    return function () {
      return clearInterval(timer);
    };
  }, [interval]);
  return time;
}